import throttle from 'lodash/throttle';
import * as React from 'react';

import styles from './MobileVillageCardPage.css';
import { EExtraVillages } from '../../../constants/village';
import { FatFeatureListContainer } from '../../../containers/FatFeatureList';
import { InfoLayoutContainer } from '../../../containers/InfoLayout';
import { MobileFatInfrastructureListContainer } from '../../../containers/MobileFatInfrastructureList';
import { GalleryLayoutContainer } from '../../../containers/MobileGalleryLayout';
import { MobilePromosContainer } from '../../../containers/MobilePromosContainer';
import { BlockErrorBoundary } from '../../BlockErrorBoundary';
import { MobileExtraVillagesContainer } from '../ExtraVillages';
import { FeaturesLayoutContainer } from '../FeaturesLayout';
import { AboutLayoutContainer } from '../about_layout/container';
import { BreadcrumbsLayout } from '../breadcrumbs_layout';
import { BuilderLayoutContainer } from '../builder_layout/container';
import { DescriptionLayoutContainer } from '../description_layout/container';
import { InfrastructureLayoutContainer } from '../infrastructure_layout/container';
import { MapLayoutContainer } from '../map_layout/container';
import { NeighborhoodLayoutContainer } from '../neighborhood_layout/container';
import { ObjectsLayoutContainer } from '../objects_layout/container';
import { ShowContactsLayoutContainer } from '../show_contacts_layout/container';

type TMobileVillageCardPageProps = {};

export class MobileVillageCardPage extends React.Component<TMobileVillageCardPageProps> {
  private header: HTMLElement | null = null;
  private lastScrollTop = 0;

  public componentDidMount() {
    window.addEventListener('scroll', this.handleScrollThrottled);
    this.header = document.getElementById('adaptive-header');
    if (this.header) {
      this.header.classList.add(styles['adaptive-header']);
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollThrottled);
    if (this.header) {
      this.header.classList.remove(styles['adaptive-header']);
    }
  }

  public render() {
    return (
      <>
        <BlockErrorBoundary>
          <GalleryLayoutContainer />
        </BlockErrorBoundary>
        <AboutLayoutContainer />
        <FatFeatureListContainer isMobile={true} />
        <MapLayoutContainer />
        <ObjectsLayoutContainer />
        <MobilePromosContainer />
        <MobileFatInfrastructureListContainer />
        <FeaturesLayoutContainer />
        <NeighborhoodLayoutContainer />
        <InfoLayoutContainer />
        <DescriptionLayoutContainer />
        <InfrastructureLayoutContainer />
        <BuilderLayoutContainer />
        <ShowContactsLayoutContainer />
        <BreadcrumbsLayout />
        <MobileExtraVillagesContainer type={EExtraVillages.Similar} />
        <MobileExtraVillagesContainer type={EExtraVillages.Nearby} />
      </>
    );
  }

  private handleScroll = () => {
    if (!this.header) {
      return;
    }

    const currentScrollTop = window.pageYOffset
      ? window.pageYOffset
      : document.documentElement && document.documentElement.clientHeight
        ? document.documentElement.scrollTop
        : document.body.scrollTop;

    const shouldHide = this.lastScrollTop < currentScrollTop;
    this.header.style.top = shouldHide ? `-${this.header.offsetHeight}px` : '0';

    this.lastScrollTop = currentScrollTop;
  };

  private handleScrollThrottled = throttle(this.handleScroll, 50);
}
